export default "__VITE_ASSET__Crx07zF___"